module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("3GliG"))).then(() => parcelRequire('3E6Ib'));